import { gql } from 'apollo-boost';

export const GET_LAYOUT_TYPE = gql`
  query layoutType {
    layoutType {
        id
        name
        description
    }
  }
`;

export const GET_LAYOUT_TYPE_BY_ID = gql`
query layoutTypeById($id: String!) {
  layoutTypeById(id: $id) {
    name
    description
    }
  }
`;

export const ADD_LAYOUT_TYPE = gql`
  mutation createLayoutType($name: String!, $description: String!) {
    createLayoutType(input: { name: $name, description: $description }) {
      id
      name
      description
    }
  }
`;

export const EDIT_LAYOUT_TYPE = gql`
  mutation updateLayoutType($id: String!, $name: String!, $description: String!) {
    updateLayoutType(id: $id, input: { name: $name, description: $description }) {
      id
      name
      description
    }
  }
`;

export const DELETE_LAYOUT_TYPE = gql`
mutation deleteLayoutType($id: String!) {
deleteLayoutType(id: $id) {
    id
  }
}
`;
